import React, { useContext, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { fetchPsfSalesDssatAllYears, fetchPsfSalesDssatMonthData } from "../psfSalesServiceKpi";
import { FilterContext } from "../../../context/Filter";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const PsfSalesDissatisfactionGraph = () => {
  const [psfDesData, setPsfDesData] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [loading, setLoading] = useState(true);
  const { arn: parArn, childArn } = useContext(FilterContext);

  const fetchAllYearsData = async () => {
    setLoading(true);
    try {
      const response = await fetchPsfSalesDssatAllYears(parArn, childArn);
      setYears(response.map((item) => item.key));
      if (!selectedYear) setPsfDesData(response);
    } catch (error) {
      console.error("Error fetching all years data:", error);
      setPsfDesData([]);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchMonthData = async (year) => {
    setLoading(true);
    try {
      const response = await fetchPsfSalesDssatMonthData(parArn, childArn, year);
      setPsfDesData(response);
    } catch (error) {
      console.error("Error fetching monthly data:", error);
      setPsfDesData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllYearsData();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      fetchMonthData(selectedYear);
    } else {
      fetchAllYearsData();
    }
  }, [selectedYear]);

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (!psfDesData || psfDesData.length === 0) {
    return <div className="text-center p-4 text-gray-500">No data available</div>;
  }

  const chartData = {
    labels: psfDesData.map((item) => item.key),
    datasets: [
      {
        label: "PSF Dissatisfaction",
        data: psfDesData.map((item) => item.dssat),
        backgroundColor: "#d9534f",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 30 } },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: {
        anchor: "end",
        align: "end",
        clip: false,
        formatter: (value) => `${value}%`,
        font: { weight: "bold", size: 14 },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { display: false, beginAtZero: true, max: 100 },
    },
  };

  return (
    <div className="w-full h-full flex flex-col items-center justify-center p-4">
      <select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        className="border rounded p-2 mb-4"
      >
        <option value="">All Years</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <div className="w-full max-w-md" style={{ height: "250px" }}>
        <Bar data={chartData} options={chartOptions} height={250} />
      </div>
    </div>
  );
};

export default PsfSalesDissatisfactionGraph;
